<template>
    <div class="page" ref="scroller">
        <van-list
            class="list"
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
        >
            <div
                class="item"
                :class="{ isRead: item.is_read }"
                v-for="item in list"
                :key="item.id"
            >
                <div class="header">
                    <div class="title">{{ item.title }}</div>
                </div>
                <div class="footer">
                    <div class="time">{{ item.pub_time }}</div>
                    <div class="goDetail" @click="goZanneixinDetail(item.id)">
                        详情
                    </div>
                </div>
            </div>
        </van-list>
        <no-content msg="'暂无站内信'" v-if="showNoContent"></no-content>
    </div>
</template>

<script>
import userCenterService from "../../service/user-center.service";
import noContent from "../../components/no-content/no-content";
import scrollerMixin from "../../scroller.mixin";
export default {
    name: "zanneixin-list",
    components: {
        "no-content": noContent
    },
    mixins: [scrollerMixin],
    data() {
        return {
            list: [],
            loading: true,
            finished: false,
            page: 0,
            showNoContent: false
        };
    },
    mounted() {
        if (this.loading) {
            this.onLoad();
        }
    },
    methods: {
        onLoad() {
            userCenterService.userLetter({ page: this.page }).then(res => {
                this.loading = false;
                this.page++;
                this.list.push(...res.data.list_data);
                if (this.list.length <= 0) {
                    this.showNoContent = true;
                    this.loading = false;
                    this.finished = true;
                }
                if (this.list.length >= res.data.count) {
                    this.finished = true;
                }
            });
        },
        goZanneixinDetail(id) {
            this.$router.push({ path: `/zanneixin-detail/${id}` });
        }
    }
};
</script>

<style lang="scss" scoped src="./zanneixin-list.scss">
</style>